var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialog)?_c('modal',{attrs:{"width":"90%"},on:{"close":_vm.closeDialog}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("Información y documentación requerida")])]),_vm._v(" "),_vm._t("content")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/RoadSinisters/CloseProject/FilesModal.vue